import { handleResponse, handleError, getApiUrl, serviceKeys } from "./apiUtils";
import getRequestOptions from './authorizationUtils';
import axios from 'axios';

export function readTenant(tenantId) {
    const options = getRequestOptions();
    return axios.get(getApiUrl(serviceKeys.tenants) + `/api/tenants/${tenantId}`, options)
        .then(handleResponse)
        .catch(handleError);
}
// bypassCache: a unique query parameter so that no HTTP or service worker cache can answer
// with a list fetched before the account was added to a tenant (a custom Cache-Control
// request header would need a CORS preflight the tenants API may not allow).
export function getAllAvailableTenants(bypassCache = false) {
    const options = getRequestOptions();
    const query = bypassCache ? `?_=${Date.now()}` : '';
    return axios.get(getApiUrl(serviceKeys.tenants) + `/api/tenants/` + query, options)
        .then(handleResponse)
        .catch(handleError);
}


